// extracted by mini-css-extract-plugin
export default {"configCard":"settings_configCard__kduRk","configLink":"settings_configLink__5-nZB"};